module.exports = __webpack_public_path__ + "static/img/employee-01-big.c2f3dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-01-big.png
// module id = XmZO
// module chunks = 2